module.exports = __webpack_public_path__ + "static/media/newsletter-march-2022-bennie-brock.e514fcad.jpg";